


















































































import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import Draggable from 'vuedraggable'
import KanbanChangeDialog from '@/components/cockpit/KanbanChangeDialog.vue'
import KanbanDetailDialog from '@/components/cockpit/KanbanDetailDialog.vue'
import KanbanCreateDialog from '@/components/cockpit/KanbanCreateDialog.vue'
import WarningDialog from '@/components/WarningDialog.vue'

interface ComponentData {
  loading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  kanbanData: any[]
  showDeleteWarningDialog: boolean
  warningDeleteMessage: string
  showKanbanChangeDialog: boolean
  showKanbanDetailDialog: boolean
  showKanbanCreateDialog: boolean
}

export default Vue.extend({
  name: 'Kanban',

  components: {
    Draggable,
    WarningDialog,
    KanbanCreateDialog,
    KanbanDetailDialog,
    KanbanChangeDialog
  },

  props: {
    tableHeight: String,
    selectedTask: Object as () => any | null,
    isKanbanCreate: Boolean,
    isKanbanDelete: Boolean
  },

  data (): ComponentData {
    return {
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      kanbanData: [],
      showDeleteWarningDialog: false,
      warningDeleteMessage: 'DELETE',
      showKanbanChangeDialog: false,
      showKanbanDetailDialog: false,
      showKanbanCreateDialog: false,
    }
  },

  watch: {
    isKanbanCreate (newVal: boolean): void {
      if(newVal) {
        this.showKanbanCreateDialog = true
      }
    },

    isKanbanDelete (newVal: boolean): void {
      if(newVal) {
        this.showDeleteWarningDialog = true
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    getTaskByStatus (status: number): any[] {
      return this.kanbanData.filter((item: any) => item.status === status)
    },

    onCloseKanbanCreateDialog (): void {
      this.$emit('stopCreate')
      this.showKanbanCreateDialog = false
    },

    onSaveKanbanCreateDialog (): void {
      this.onCloseKanbanCreateDialog()
    },

    onWarningDeleteDialogClose (): void {
      this.$emit('stopDelete')
      this.showDeleteWarningDialog = false
    },

    onWarningDeleteDialogSave (): void {
      this.onWarningDeleteDialogClose()
    },

    onTaskClick (item: any): void {
      this.$emit('selectTask', this.selectedTask && this.selectedTask.id === item.id ? null : item)
    },

    onDblTaskClick (item: any): void {
      this.$emit('selectTask', item)
      this.showKanbanDetailDialog = true
    },

    onCloseKanbanDetailDialog (): void {
      this.showKanbanDetailDialog = false
    },

    onSaveKanbanDetailDialog (): void {
      this.showKanbanDetailDialog = false
    },


    onMove(evt: any, originalEvent: any) {
      // evt obsahuje napr. evt.draggedContext, evt.relatedContext, atď.
      //console.log('Moving item:', evt);

      // napríklad nepovoľ presun, ak sa presúva do určitej kolónky
      if (evt.to.id === 'column8') {
        return false; // zablokuje presun
      }

      return true; // povolí presun
    },

    draggableChange (evt: any): void {
      //console.log('teraz')
      //console.log(evt)
      this.showKanbanChangeDialog = true
    },

    onCloseKanbanChangeDialog (): void {
      this.showKanbanChangeDialog = false
    },

    onSaveKanbanChangeDialog (): void {
      this.showKanbanChangeDialog = false
    },
  },

  created (): void {

  },

  mounted() {

    const data: any[] = [
      { id: 1, name: 'Neue Bewerbung', color: 'rgba(33, 150, 243)', color2: 'rgba(33, 150, 243, 0.2)', items: [
          {id: 11, name: `Peter Krnáč`, date: '13.08.2025', responsible: 'Eva Cronauer', status: 1},
          {id: 12, name: `Jana Vajglova`, date: '01.08.2025', responsible: 'Eva Cronauer', status: 1},
          {id: 13, name: `Mirelinda Palushaj`, date: '20.04.2025', responsible: 'Eva Cronauer', status: 1}
        ] },
      { id: 2, name: 'Kontakt', color: 'rgba(33, 150, 243)', color2: 'rgba(33, 150, 243, 0.2)', items: [] },
      { id: 3, name: 'Unterlagen', color: 'rgba(33, 150, 243)', color2: 'rgba(33, 150, 243, 0.2)', items: [] },
      { id: 4, name: 'Abklärungen', color: 'rgba(255, 152, 0)', color2: 'rgba(255, 152, 0, 0.2)', items: [
          {id: 41, name: `Anett Fodor`, date: '13.08.2025', responsible: 'Eva Cronauer', status: 4},
          {id: 42, name: `Ruth Oswald`, date: '01.08.2025', responsible: 'Eva Cronauer', status: 4},
        ] },
      { id: 5, name: 'Vorstellungsgespräch', color: 'rgba(255, 152, 0)', color2: 'rgba(255, 152, 0, 0.2)', items: [] },
      { id: 6, name: 'Probearbeiten', color: 'rgba(255, 152, 0)', color2: 'rgba(255, 152, 0, 0.2)', items: [
          {id: 61, name: `Shirin Arfo`, date: '20.04.2025', responsible: 'Eva Cronauer', status: 4},
        ] },
      { id: 7, name: 'Vertragsabschluss', color: 'rgba(76, 175, 80)', color2: 'rgba(76, 175, 80, 0.2)', items: [
          {id: 71, name: `Ouafae Azzouz`, date: '20.04.2025', responsible: 'Eva Cronauer', status: 4},
        ] },
      { id: 8, name: 'Absage', color: 'rgba(244, 67, 54)', color2: 'rgba(244, 67, 54, 0.2)', items: [] },
    ]

    this.kanbanData = data

  }
})
